import { render, staticRenderFns } from "./openpose.md?vue&type=template&id=1a369ca2&"
import script from "./openpose.md?vue&type=script&lang=js&"
export * from "./openpose.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports